import { createQueryHook } from "../factory";

const insurerKeys = {
  all: ["insurers"] as const,
  lists: () => [...insurerKeys.all, "list"] as const,
  list: <T>(filters: T) => [...insurerKeys.lists(), filters] as const,
};

export const insurers = {
  getInsurers: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.insurers.getInsurers,
    queryKeyFn: insurerKeys.list,
  }),
};
